module.exports = __webpack_public_path__ + "img/completed_delivery.3a2061a9.svg";